import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

/**
 * 查询
 * @param {*} s
 */
export const queryComponentRole = params => {
    return request({
        url: requestUrl('/role/queryComponentRole'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 新增
 * @param {*} s
 */
export const saveComponentRole = params => {
    return request({
        url: requestUrl('/role/saveComponentRole'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 删除
 * @param {*} s
 */
export const deleteComponentRole = params => {
    return request({
        url: requestUrl('/role/delete'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 修改
 * @param {*} s
 */
export const updateComponentRole = params => {
    return request({
        url: requestUrl('/role/updateComponentRole'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 菜单查询
 * @param {*} s
 */
export const queryClientMenu = params => {
    return request({
        url: requestUrl('/client/site/queryClientMenu '),
        method: 'post',
        data: requestParam(params)
    });
};